import { reactive } from 'vue';
export const store = reactive(
    {
        alerts:[],
        loaded: false,
        show: false,
        read: []
    }
);

export const actions = {
    init: function() {
        if (localStorage.getItem('read_notifications')) {
            try {
                const parsed = JSON.parse(localStorage.getItem('read_notifications'));
                if (!Array.isArray(parsed)) {
                    store.read = [];
                } else {
                    store.read = parsed;
                }
                for(let i = 0; i < store.read.length; i++) {
                    if (!Number.isInteger(store.read[i]) ) {
                        store.read = [];
                        break;
                    }
                }
            } catch (error) {
                store.read = [];
            }
        }
        
        let base_url = '/wp-json/base/v1/alerts';
        if ( ! store.loaded) {
            fetch(base_url)
            .then((res)=>res.json())
            .then((data)=>{
                if (data.length) {
                    store.alerts = data;
                    store.loaded = true;
                }
            })
        }
    },
    storeRead: function(id) {
        let read = []
        if (localStorage.getItem('read_notifications')) {
            try {
                read = JSON.parse(localStorage.getItem('read_notifications'));
            } catch (error) {
                read = [];
            }
            
            if (!Array.isArray(read)) return;
            for(let i = 0; i < read.length; i++) {
                if (!Number.isInteger(read[i]) ) {
                    return;
                }
            }
        } 
        
        read.push(id);
        localStorage.setItem('read_notifications', JSON.stringify(read));
    }
    

}

export const getters = {
    count: ()=> store.alerts.length,
    alerts: () => store.alerts,
    show: ()=>store.show,
    count_unread: ()=> store.alerts.length - store.read.length,
    isRead: (id) => store.read.indexOf(id) != -1
    
}

export const setters = {
    show: (show) => {
        let body = document.getElementsByTagName('body');
        if(show) {
            body[0].style.overflow = 'hidden';
        } else {
            body[0].style.overflow = 'unset';
        }
        store.show = show
    },
    isRead: (id) => {
        
        if( ! getters.isRead(id)) {
            store.read.push(id)
            actions.storeRead(id)
        }
        
    }
}
